import {
  GraphQLClient,
  type RequestOptions,
  type TypedDocumentString,
  type Variables,
} from 'graphql-request';

import { getAnonymousId } from '../shared/trackers';

let client: GraphQLClient | undefined;

const getClient = () => {
  if (typeof window === 'undefined') {
    throw new Error('The Cosmos Zeus visitor client requires a browser origin');
  }
  client ??= new GraphQLClient(new URL('/api/zeus', window.location.href).toString(), {
    credentials: 'include',
    headers: {
      'apollographql-client-name': 'cosmos',
      'apollographql-client-version': process.env.NEXT_PUBLIC_VERSION ?? 'local',
    },
  });
  return client;
};

export const requestZeus = <TResult, TVariables extends Variables>(
  document: TypedDocumentString<TResult, TVariables>,
  variables: TVariables,
  signal?: AbortSignal,
): Promise<TResult> => {
  const anonymousId = getAnonymousId();
  const options: RequestOptions<Variables, TResult> = {
    document,
    variables,
    ...(anonymousId ? { requestHeaders: { 'x-opendoor-anonymous-id': anonymousId } } : {}),
    ...(signal ? { signal } : {}),
  };

  return getClient().request<TResult>(options);
};
